import widgetsService from 'live/services/widgets'
import wbsDataReducer from './wbsDataReducer'
import WBSChart from './WBSChart'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import React from 'react'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import thumbnail from '../../../assets/img/wbs.png'
import WBSChartOptions from './chartOptions'
import { WrapperConfigs } from './types'

const type = 'wbs'

widgetsService.config(type, {
    objectType: 'trajectory',
    zoomStatus: null,
    span: 'ts 0 to ts 8000',
    syncTooltip: false,
    spanPicker: {
        type: 'depth',
        configs: {
            depth: {}
        }
    }
})
widgetsService.name(type, 'Wellbore Stability')
widgetsService.description(type, 'Wellbore Stability (WBS) chart')
widgetsService.impl(
    type,
    widgetWrapper(WBSChart, wbsDataReducer, {
        mapConfigToRender(configs: WrapperConfigs) {
            const getFilter = (): string => {
                if (configs.dashboardContext.params.filter) {
                    const obj = JSON.parse(configs.dashboardContext.params.filter)
                    if (obj.asset_name_event_type && obj.asset_name_event_type.length) {
                        return obj.asset_name_event_type[0]
                    }
                } else {
                    return ''
                }
            }
            let zoomStatus = configs.widget.jsonConfig.zoomStatus

            // check for legacy followBitDepth
            // remove after mid 2021
            if (configs.widget.jsonConfig.followBitDepth) {
                configs.widgetContext.actions.changeConfig('followBitDepth', false)
                configs.widgetContext.actions.changeConfig('zoomStatus', 'followBitDepth')
                zoomStatus = 'followBitDepth'
            }

            return {
                widget: configs.widget,
                changeConfig: configs.widgetContext.actions.changeConfig,
                syncTooltip: configs.widget.jsonConfig.syncTooltip,
                zoomStatus: zoomStatus,
                dashboardTheme: configs.dashboardContext.theme,
                filter: getFilter()
            }
        },
        sampleTime: 500
    })
)
widgetsService.queryHandlerKind(type, type)
widgetsService.policies(type, {
    layers: 3,
    defaultReducer: '@latest',
    handleOwnMissingData: true
})

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('Wellbore Stability'),
        description: i18n('Visualize Gamma ray and resistivity logs plotted against lithology and trajectory'),
        thumbnail: thumbnail
    },
    [<WBSChartOptions />]
)
